/** A teacher's read of course publication: the registrar's act, never a teacher control (P3B-02). */
import type { FactBox, Read } from "@/components/ui/box.schema";
import type { Course } from "@/lib/api/courses";
import { registrarCourseCopy as words } from "./registrar-course-copy";

/** It says the state and what follows, never a resting read time: the teacher reads, the registrar acts (#1416). */
export function teachingPublicationBox(recordId: string, read: Read<Course>): FactBox<Course> {
  const said = (course: Course) => words.teachingPublication[course.status];
  return {
    id: `publication-${recordId}`, kind: "fact", label: words.publication, job: words.teachingPublicationJob, owner: { system: "imam" },
    read, fold: "never", prose: course => said(course).state, detail: course => said(course).next, body: course => <p>{said(course).next}</p>,
  };
}
